import {Button, Card, Col, Container, Form, Row} from "react-bootstrap";
import styles from "./login.module.css";
import keySvg from "../../icons/login.svg"
import LoginForm from "./forms/LoginForm";
import {useTranslation} from "react-i18next";

const Login = (props) => {


    const {t} = useTranslation();

    return (
        <Container fluid={true} className={'login bg-light h-100 d-flex justify-content-center'}>
            <Row>
                <Col className={styles.cardWrapper}>
                    <Card className={styles.card}>
                        <Card.Title className={styles.title}>
                            <div className={styles.keyIconBg}><img className={styles.keyIcon} width={"32rem"}
                                                                   src={keySvg}/></div>
                            {t('login.header')}
                        </Card.Title>
                        <Card.Body className={styles.cardBody}>
                            <LoginForm/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;